import "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "../jquery.countdown.min.js";
import Cookies from "js-cookie";
import "../utils.js";
import "../jquery.typeahead.js";
import "../search";
import "./search-association"
import "./createsaleslinkblock"
import "../typeform";
import "../widgets/folkspel2/typeform.js";
import Handlebars from "handlebars/dist/handlebars.js";
import "../widgets/folkspel2/verificationPage.js";

$(function () {
    //Header on scroll

    var lastScrollTop = 0;

    $(window).scroll(function () {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            // downscroll code
            $("header").toggleClass("scrolled-top", $(this).scrollTop() < 25);
            $("header").removeClass("scrolled-up", $(this).scrollTop() < 25);
        } else if ($(this).scrollTop() < 50 && $(window).width() > 1024) {
            // scroll to top - not over 50px from top - desktop
            $("header").toggleClass("scrolled-top", $(this).scrollTop() < 25);
            $("header").removeClass("scrolled-up", $(this).scrollTop() < 50);

        } else if ($(this).scrollTop() < 50 && $(window).width() < 1024) {
            // scroll to top - not over 50px from top - mobile
            $("header").toggleClass("scrolled-top", $(this).scrollTop() < 25);
            $("header").removeClass("scrolled-up", $(this).scrollTop() < 25);

        } else {
            // upscroll code
            $("header").toggleClass("scrolled-up", $(this).scrollTop() > 50);
        }
        lastScrollTop = st;
    });

    $(window).resize(function () {
        if ($(window).width() > 1024) {
            $("header").removeClass("open");
            $("body").removeClass("fixedPosition");
        }
    });

    $(".header__hamburger").click(function () {
        $("header").toggleClass("open");
        $("body").addClass("fixedPosition");
        if (!$("header").hasClass("open")) {
            $("header").removeClass("open");
            $("body").removeClass("fixedPosition");
        }
    });

    //Heroblock video play button
    $(".heroblock__play").click(function () {
        $(this).toggleClass("played");
        let id = $(this).attr("video-id");
        if (id) {
            let video = $("#" + id).find("video");
            if (video) {
                video.get(0).play();
            }
        }
    });

    //Check if startpage - header icon show
    if ($(".start-page")[0]) {
        $(".header").toggleClass("show-icon");
    }

    //Check if autorblock is shown
    if ($(".articleauthorblock")[0] && !$(".news-page")[0]) {
        $(".share").toggleClass("absolute-position");
    }

    //Check if right column is shown for standardpage
    if ($(".standard-page__aside")[0]) {
        $(".news-page").toggleClass("has-right-column");
        $(".news-page__date").toggleClass("standard-page__main");
        $(".news-page__blocks").toggleClass("standard-page__main");

        $(".nominee-page").toggleClass("has-right-column");
        $(".nominee-page__category").toggleClass("standard-page__main");
        $(".nominee-page__voting").toggleClass("standard-page__main");
    }

    //Load more links linklistautoblock
    $("#loadMoreLinksButton").click(function () {
        $(".linklistautoblock__link").toggleClass("show");
        $(".linklistautoblock__show-more").toggleClass("hide");
    });

    //Load more files linklistmanualblock
    $("#loadMoreFilesButton").click(function () {
        $(".linklistmanualblock__link").toggleClass("show");
        $(".linklistmanualblock__show-more").toggleClass("hide");
    });

    $(".customerserviceblock form").each(function () {
        var $form = $(this),
            $fields = $("div[data-topic]", $form),
            $select = $("select", $form),
            $feedback = $("div[data-success-message]", $form);

        // If form has no validator, maybe form was inserted dynamically, try trigger unobtrusive
        if (!$form.data("validator")) {
            $.validator.unobtrusive.parse($self);
        }

        function submitForm() {
            $feedback.hide();

            var data = {
                request: {
                    contactformid: $("option:selected", $select).val(),
                    message: $("textarea", $form).val(),
                    name: $("input[name='Name']", $form).val(),
                    email: $("input[name='EmailAddress']", $form).val(),
                    phone: $("input[name='PhoneNumber']", $form).val(),
                    blockid: $("input[name='BlockId']", $form).val(),
                    language: $("input[name='Language']", $form).val(),
                    additionalfields: []
                }
            };

            $("div[data-topic]:visible", $form).each(function () {
                var $topic = $(this);
                data.request.additionalfields.push({
                    Name: $("input", $topic).attr("id"),
                    Value: $("input", $topic).val()
                });
            });
            $("#customerserviceblock__submit").addClass("loading");

            $.ajax({
                url: $form.attr("action"),
                method: "POST",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(data),
                success: function (response) {
                    if (response.Success) {
                        $feedback.html($feedback.data("success-message"));
                    } else {
                        $feedback.html($feedback.data("error-message"));
                        $feedback.addClass("error-message");
                    }
                },
                error: function () {
                    $feedback.html($feedback.data("error-message"));
                },
                complete: function () {
                    $("#customerserviceblock__submit").removeClass("loading");
                    $feedback.addClass("submit-message");
                    $feedback.show();
                }
            });
        }

        if ($form.data("validator")) {
            // Form is validated by jquery.validate, attach to submit by submithandler
            $form.data("validator").settings.submitHandler = function () {
                submitForm();
            };
        }
        else {
            // Form is not validated, attach to regular submit-event.
            $form.submit(function (e) {
                e.preventDefault();
                submitForm();
            });
        }

        $select.change(function () {
            var value = $("option:selected", $select).val();
            $fields.hide();
            if (value === "") return;
            $(`div[data-topic='${value}']`).show();
        });
    });

    $(".faqblock").each(function () {
        var $block = $(this),
            $select = $("select", $block),
            $questions = $("ul[data-subjectid]", $block);

        $("li h3", $questions).click(function (e) {
            e.preventDefault();
            $("span", $(this).parent()).toggle();
        });

        $select.change(function () {
            var value = $("option:selected", $select).val();
            $("li span", $questions).hide();
            $questions.hide();
            $(`ul[data-subjectid='${value}']`).show();
        });
    });

    //Mosaic block grid
    function resizeGridItem(item) {
        var grid = document.getElementsByClassName("mosaicblock__list")[0];
        var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-auto-rows"));
        var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-row-gap"));
        var rowSpan = Math.ceil((item.querySelector(".mosaicblock__item-container").getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
        item.style.gridRowEnd = "span " + rowSpan;
    }

    function resizeAllGridItems() {
        var allItems = document.getElementsByClassName("mosaicblock__item");
        for (var x = 0; x < allItems.length; x++) {
            resizeGridItem(allItems[x]);
        }
    }

    window.onload = resizeAllGridItems();
    window.addEventListener("resize", resizeAllGridItems);

    var allItems = document.getElementsByClassName("mosaicblock__item");
    for (var x = 0; x < allItems.length; x++) {
        imagesLoaded(allItems[x], resizeInstance);
    }

    function resizeInstance(instance) {
        var item = instance.elements[0];
        resizeGridItem(item);
    }

    $("body").on("EPiServerFormsSubmitted", function () {
        setTimeout(function () { $.modal.close(); }, 1000);
    });


    $(".azurevideolimitedtimeblock div[data-id]").each(function () {

        var $self = $(this),
            id = $self.data("id"),
            $container = $(`#${id}`),
            $overlay = $(".overlay", $container.parent()),
            video = $self.data("video"),
            startTime = new Date($self.data("starttime")),
            endTime = new Date($self.data("endtime")),
            $icon = $("span.expand", $self),
            player,
            options = {
                nativeControlsForTouch: false,
                autoplay: true,
                muted: true,
                width: "100%",
                height: "100%",
                plugins: {
                    ga: {
                        "eventsToTrack": [
                            "playerConfig", "loaded", "playTime", "percentsPlayed", "start", "end", "play", "pause",
                            "error", "buffering", "fullscreen", "seek", "bitrate"
                        ],
                        "debug": false
                    }
                }
            };

        function unMuteVideo() {
            if (player) {
                player.muted(false);
            }
            $overlay.off("click", unMuteVideo).addClass("hide");
        }

        if (endTime.getTime() > new Date().getTime()) {
            $(".starttime", $self).countdown(startTime).on("finish.countdown", function () {
                $("img", $container.parent()).hide();
                $overlay.removeClass("hide");
                $icon.removeClass("hide");
                $container.removeClass("hide");
                player = amp(id, options).ready(function () {
                    player.play();
                });
                player.src([
                    {
                        "src": video,
                        "type": "application/vnd.ms-sstr+xml"
                    }
                ]);
                player.addEventListener("start", function () {
                    try {
                        var startingAt = Math.round((new Date().getTime() - startTime.getTime()) / 1000);
                        player.currentTime(startingAt);
                    } catch (e) {
                        console.error(e);
                    }
                });
                $icon.get(0).addEventListener("click", function () {
                    if (player.isFullscreen()) {
                        player.exitFullscreen();
                    } else {
                        player.enterFullscreen();
                    }
                });
            }).countdown("start");

            $(".endtime", $self).countdown(endTime).on("finish.countdown",
                function () {
                    if (player) {
                        player.pause();
                        player.dispose();
                    }
                    $("img", $container.parent()).show();
                    $overlay.addClass("hide");
                    $icon.addClass("hide");
                    $container.addClass("hide");
                }).countdown("start");

            $overlay.on("click", unMuteVideo);
        }
    });

});

// voting nomine new
window.OnValidateVote = function (votedId, nomineeId) {
    var cookieExisted = Cookies.get(votedId);
    if (cookieExisted) {
        $(".nominee_" + nomineeId).removeClass("voted-success").addClass("already-voted");
        $(".nominee_" + nomineeId).html($("#votingAlreadyDoneMsg").first().html())
        return false;
    }
    return true;
}
window.OnCommentpostSuccess = function (response) {
    $(".nominee_" + response.data.nomineeId).html(response.msg);
    if (response.isError) {
        $(".nominee_" + response.data.nomineeId).removeClass("already-voted").removeClass("voted-success").addClass("voted-error");
    }
    else {
        $(".nominee_" + response.data.nomineeId).removeClass("already-voted").removeClass("voted-error").addClass("voted-success");
        Cookies.set(response.data.votedId, (new Date()).toString(), { expires: 9999 });
        window.Utils.TrackGoogleEvent("Enthusiast", "NomineeVote", window.btoa(response.data.nomineeName.trim()));
    }
}
window.OnCommentpostFailure = function (response) {
    $(".nominee_" + response.data.nomineeId).html(response.msg);
};

window.OnCommentpostComplete = function (response) {
}

window.onClickDoVote = function (formId, votedId, nomineeId) {
    var validateResult = OnValidateVote(votedId, nomineeId);
    if (!validateResult) return false;

    var form = $('#' + formId);
    $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: form.serialize(),
        success: function (result) {
            OnCommentpostSuccess(result)
        }
    });
    return false;
}

$(function () {

    $('.profitsearchblock__section').each(function () {
        let $this = $(this),
            $searchbox = $("#searchAssociation", $this),
            $noResults = $(".no-results", $this),
            $searchPhrase = $(".search-phrase", $noResults),
            $results = $(".results", $this),
            $resultItemSource = $("#associationTemplate", $this).html(),
            itemTemplate = Handlebars.compile($resultItemSource),
            timeout = null,
            $benefits = $('.associationBenefit', $this),
            $borders = $('.associationSearchResult', $this),
            $noBenefitDisplay = $('.associationWithoutBenefits', $this);

        let handleSearchResult = function (resultList) {
            $results.empty();
            $results.show();
            $benefits.hide();
            $noBenefitDisplay.hide();

            $noResults.hide();
            if (resultList.results.length < 1) {
                $searchPhrase.text($searchbox.val());
                $borders.hide();
                $noResults.show();
            } else {
                $.each(resultList.rawResults, function (index, value) {
                    var html = itemTemplate(value);
                    $results.append(html);
                });
            }
        }

        let handleSearchError = function (err) {
            $results.empty();
            $noResults.hide();
        }

        let search = function (searchText) {
            window.fsSearch.searchAssociation(searchText)
                .then(handleSearchResult, handleSearchError)
                .catch(error => {
                    console.log(`error: ${error}`);
                });
        }

        let autoSearch = function () {
            var searchText = $searchbox.val();
            if (searchText.length > 2) {
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(() => search(searchText), 200);
            }
        }

        $searchbox.keyup(autoSearch);

        $searchbox.keypress(function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                event.preventDefault();
                autoSearch();
            }
        });


        addEventListener('click', (event) => {
            if (!event.target.closest('.results')) {
                $('.results').hide();
            }
        });

    })



});
//End of ProfitSearchBlock

var common = require.context("../widgets/common/", true, /\.js$/);
common.keys().forEach(common);
var folkspel2 = require.context("../widgets/folkspel2", true, /\.js$/);
folkspel2.keys().forEach(folkspel2);

